import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class StaticJsonDataService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  static readonly JSON_DATA_DIR_URL: string = 'assets/json';
  static readonly ERROR_MESSAGE: string =
    'Something went wrong during static json data fetch: ';

  isBrowser = false;

  fetchJsonData(jsonDataUrl: string): Promise<any[]> {
    // if (!this.isBrowser) {
    //   return Promise.resolve([]);
    // }

    return fetch(`${StaticJsonDataService.JSON_DATA_DIR_URL}/${jsonDataUrl}`)
      .then((response: Response) => response.json())
      .then((jsonData: any) => { return jsonData; })
      .catch((error) => this.defaultErrorHandler(error, jsonDataUrl));
  }

  private defaultErrorHandler(error: any, jsonDataUrl: string): Promise<any> {
    console.warn(StaticJsonDataService.ERROR_MESSAGE, error, jsonDataUrl);
    return Promise.reject(error);
  }
}
